// NavigationMenu.js
import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import MultiLevelMenubar from './MultiLevelMenubar';
import SchoolSearch from './SchoolSearch';

const NavigationMenu = () => {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSchoolForm, setShowSchoolForm] = useState(false);
  const [clickedMenu, setClickedMenu] = useState(null); // State to track the clicked menu

  useEffect(() => {
    const fetchMenuData = async () => {
      try {
        const response = await fetch('/system/menu/main/linkset');
        const data = await response.json();
        const items = data.linkset[0].item;

        const hierarchy = [];
        items.forEach((item) => {
          const levels = item.hierarchy.map(Number);
          let currentLevel = hierarchy;

          levels.forEach((level, index) => {
            if (!currentLevel[level]) {
              currentLevel[level] = {
                category: index === levels.length - 1 ? item.title : null,
                subcategories: [],
                href: item.href || '#',
              };
            }
            if (index === levels.length - 1) {
              currentLevel[level].category = item.title;
              currentLevel[level].href = item.href || '#';
            } else {
              currentLevel = currentLevel[level].subcategories;
            }
          });
        });

        setMenuItems(hierarchy);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching menu data:', error);
        setLoading(false);
      }
    };

    fetchMenuData();
  }, []);

  const handleMenuClick = (index) => {
    // Toggle the clicked menu
    setClickedMenu((prev) => (prev === index ? null : index));
  };

  const renderMenuItems = (items) => {
    return items.map((item, index) => {
      if (item.category === "Shop All") {
        return (
          <li className="nav-item" key={index}>
            <MultiLevelMenubar data={item.subcategories} menuWidth="22rem" />
          </li>
        );
      }

      if (item.category === "Shop My School") {
        return (
          <li className="nav-item dropdown" key={index}>
            <a
              className="nav-link"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowSchoolForm(!showSchoolForm);
              }}
            >
              {item.category}
            </a>
            {showSchoolForm && <SchoolSearch subcategories={item.subcategories} />}
          </li>
        );
      }

      return (
        <li className="nav-item dropdown" key={index}>
          <a
            className="nav-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleMenuClick(index);
            }}
          >
            {item.category}
          </a>
          {clickedMenu === index && item.subcategories && item.subcategories.length > 0 && (
            <ul className="dropdown-menu">
              {item.subcategories.map((subItem, subIndex) => (
                <li key={subIndex}>
                  <a className="dropdown-item" href={subItem.href}>
                    {subItem.category}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </li>
      );
    });
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container">
        <a className="navbar-brand" href="#">
          <img
            src="https://d3qsmzzpeeacu6.cloudfront.net/s3fs-public/media/balfour/balfourco_new_logo.svg"
            alt="Balfour"
            height="40"
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          {loading ? (
            <span className="navbar-text">Loading...</span>
          ) : (
            <ul className="navbar-nav mx-auto">{renderMenuItems(menuItems)}</ul>
          )}
          <div className="nav-icons">
            <a href="#" className="cart-icon">
              <i className="bi bi-cart"></i>
              <span className="cart-count">0</span>
            </a>
            <a href="#" className="user-icon">
              <i className="bi bi-person"></i>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavigationMenu;